import React from 'react'
import Navbar from './Navbar/NavbarContainer'
import Body from './Body/BodyContainer'

const Main = () => {
  return (
    <React.Fragment>
      <Navbar />
      <Body />
    </React.Fragment>
  )
}

export default Main